// Products list page render. Takes `products` as an explicit argument
// (same dependency-injection pattern as the services) rather than closing
// over the app's mutable PRODUCTS global. Every onclick="..." in the
// returned HTML (editProduct(...), delProduct(...)) is untouched — this
// only moves what builds the string. See REFACTOR_SECURITY_REPORT.md,
// Phase 2 section.
import { esc, money } from '../utils/format.js';
import { ic } from '../utils/icons.js';
import { productThumb } from '../components/labels.js';
import { stockMeta } from '../services/inventory.js';
import { can, PERMISSIONS } from '../app/permissions.js';

export function viewProducts(products) {
  let h = '<div class="toolbar">' + (can(PERMISSIONS.MANAGE_PRODUCTS) ? '<button class="btn primary" onclick="editProduct()">' + ic('plus', 15) + 'Ajouter un produit</button>' : '') + '</div>';
  h += '<div class="card"><div class="bd" style="padding:0;overflow:auto">';
  if (!products.length) h += '<div class="empty">Aucun produit.</div>';
  else {
    h += '<table><thead><tr><th>Produit</th><th>Stock</th><th>Coût</th><th>Prix</th><th>Marge</th><th></th></tr></thead><tbody>';
    products.forEach(p => {
      const marg = Number(p.price || 0) - Number(p.cost || 0), sm = stockMeta(p);
      h += `<tr><td class="bidi"><div class="product-cell">${productThumb(p)}<b>${esc(p.name)}</b></div></td><td><span class="stock-number">${Number(p.stock || 0)}</span><br><span class="stock-level ${sm.key}">${sm.label}</span></td><td>${money(p.cost)}</td><td>${money(p.price)}</td><td><span class="chip ${marg >= 0 ? 'g' : 'r'}">${marg >= 0 ? '+' : ''}${Math.round(marg)} DH</span></td><td class="qa"><button class="iconbtn" title="Modifier" onclick="editProduct('${p.id}')">${ic('edit', 15)}</button>${can(PERMISSIONS.DELETE_PRODUCT) ? `<button class="iconbtn r" title="Supprimer" onclick="delProduct('${p.id}')">${ic('trash', 15)}</button>` : ''}</td></tr>`;
    });
    h += '</tbody></table>';
  }
  return h + '</div></div><p class="hint" style="margin-top:10px">Le coût sert à calculer le bénéfice. Gérez les entrées et sorties rapides dans « Stock ».</p>';
}
